"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateInTimezone = formatDateInTimezone;
exports.getTimezoneAbbreviation = getTimezoneAbbreviation;

var _timezoneMapping = _interopRequireDefault(require("./timezoneMapping"));

/**
 * Native timezone utilities to replace moment-timezone library
 * Provides timezone functionality using native JavaScript APIs for better performance
 */

/**
 * Get timezone abbreviation for a given timezone
 * @param eventDate - Optional time of the event
 * @param timezone - Optional timezone identifier, defaults to user's timezone
 * @returns Timezone abbreviation (e.g., 'EST', 'PST', 'UTC')
 */
function getTimezoneAbbreviation(eventDate, timezone) {
  try {
    var date = eventDate !== null && eventDate !== void 0 ? eventDate : new Date();
    var options = {
      timeZone: timezone !== null && timezone !== void 0 ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone,
      timeZoneName: 'long'
    };
    var formatter = new Intl.DateTimeFormat('en-US', options);
    var parts = formatter.formatToParts(date);
    var timeZonePart = parts.find(function (part) {
      return part.type === 'timeZoneName';
    });

    if (timeZonePart !== null && timeZonePart !== void 0 && timeZonePart.value) {
      var _timeZoneMapping$time;

      // Use the existing timezone mapping to get the abbreviation
      return (_timeZoneMapping$time = _timezoneMapping.default[timeZonePart.value]) !== null && _timeZoneMapping$time !== void 0 ? _timeZoneMapping$time : timeZonePart.value;
    }

    return 'UTC';
  } catch (error) {
    // Fallback to UTC if timezone is invalid
    return 'UTC';
  }
}
/**
 * Format a date in a specific timezone
 * @param date - Date to format
 * @param timezone - Timezone identifier
 * @param format - Format type ('z' for timezone abbreviation)
 * @returns Formatted timezone string
 */


function formatDateInTimezone(date, timezone) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'z';

  try {
    if (format === 'z') {
      return getTimezoneAbbreviation(date, timezone);
    }

    var options = {
      timeZone: timezone,
      timeZoneName: 'short'
    };
    var formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
  } catch (error) {
    // Fallback to UTC if timezone is invalid
    return 'UTC';
  }
}